exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--2hAMj {\n  padding: 0 0;\n  position: relative;\n}\n\n.wrapper--2hAMj > div {\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  margin-right: 20px;\n}\n\n.wrapper--2hAMj:after {\n  content: \"\";\n  position: absolute;\n  width: 1px;\n  height: 50%;\n  background: #FFFFFF;\n  right: 4px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n      -ms-transform: translateY(-50%);\n          transform: translateY(-50%);\n  opacity: 0.2;\n}\n\n.label--35E3q {\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 400;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--2hAMj",
	"label": "label--35E3q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/controls/OktellControls/OktellControls.m.scss
// module id = 1293
// module chunks = 0